import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './components/AppContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config, { loadConfig } from './config';

(async () => {
  await loadConfig(); // Cargar configuración dinámica
  console.log('%c[fdvbanc] apiBaseUrl:', 'font-weight: bold; color: #3F51B5;', config.apiBaseUrl);
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    /*<React.StrictMode>*/
      <GoogleOAuthProvider clientId="43506713562-ge5qotf07eume9faal0262qajr1cmj6t.apps.googleusercontent.com">
        <AppProvider>
          <App />
        </AppProvider>
      </GoogleOAuthProvider>
    /*</React.StrictMode>*/
  );
  
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();  
})();

